export default "__VITE_ASSET__DoUFIozK__"